var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 10.833C8.69186 11.3114 9.14845 11.7073 9.67278 11.9938C10.1971 12.2802 10.7769 12.4506 11.3729 12.4933C11.9688 12.5359 12.567 12.45 13.1268 12.2411C13.6866 12.0323 14.1949 11.7055 14.6173 11.283L17.1173 8.78298C17.8763 7.99714 18.2963 6.94463 18.2868 5.85214C18.2773 4.75965 17.8391 3.7146 17.0666 2.94207C16.294 2.16953 15.249 1.73133 14.1565 1.72184C13.064 1.71234 12.0115 2.13232 11.2257 2.89131L9.79232 4.31631",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6659 9.16702C11.308 8.68858 10.8514 8.2927 10.3271 8.00623C9.80274 7.71977 9.22293 7.54942 8.62698 7.50674C8.03103 7.46406 7.43287 7.55004 6.87307 7.75887C6.31327 7.96769 5.80493 8.29446 5.38252 8.71702L2.88252 11.217C2.12353 12.0029 1.70355 13.0554 1.71305 14.1479C1.72254 15.2403 2.16075 16.2854 2.93328 17.0579C3.70581 17.8305 4.75087 18.2687 5.84335 18.2782C6.93584 18.2877 7.98835 17.8677 8.77419 17.1087L10.1992 15.6837",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.a60303fe07a3f1dd8ee672f66d3b503b.svg";
export { ForwardRef as ReactComponent };